<template>
  <div class="buttonPage absolute_center" :class="{_boxBg_green_secondLevel:styleType == 'typeGreen',_boxBg_dark_secondLevel:styleType == 'typeDark' ,_boxBg_blue_secondLevel:styleType == 'typeBlue', _boxBg_strong_secondLevel: styleType == 'typeStrong',}">
    <div class="selfClose_btn" style="top:10px" @click="close"></div>
    <div class="_boxTitle">{{title}}</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="page1" v-show="detailShow">
        <div class="check_box">
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
            <el-form-item label="日期：">
              <DatePicker
                :init-width="'420px'"
                :formatType="'YYYY-MM-DD HH:mm:ss'"
                dateType="timerange"
                :currentDateList="materialDate"
                :needInitTime="false"
                :topPx="'50px'"
                :leftPx="'-200px'"
                @dateChange="changeTime"
              >
              </DatePicker>
            </el-form-item>
            <el-form-item label="物料名：">
              <el-input v-model="material" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label=" ">
              <a class="self_btn" @click="getMaterialList()">查询</a>
              <a class="self_btn" @click="reset()">重置</a>
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box" style="height: 640px;">
          <el-table :data="tableData" style="width: 100%" @row-click="rowClick" :header-cell-class-name="'thClass'" :header-row-class-name="'headTrClass'" :cell-class-name="'tdClass'"
                    :row-class-name="'trClass'" class="secondLevel_table">
            <el-table-column prop="transportName" :show-overflow-tooltip="true" label="物料名称" align="center"></el-table-column>
            <el-table-column prop="transportVolume" label="物料总重量（吨）" align="center"></el-table-column>
            <el-table-column  prop="frequency" label="物料总批次（车次总数）" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="page_box secondLevel-pagination_box pagination">
          <el-pagination @current-change="handleCurrentChange" :current-page="params.pageNo" :page-size="params.pageSize" layout="total,prev, pager, next, jumper" :total="page_total"></el-pagination>
          <p>跳转</p>
        </div>
      </div>
      <div class="page2" v-show="!detailShow">
        <div class="selfReturn_btn" style="top:10px" @click="returnClick"></div>
<!--        <div class="check_box">
          <el-form :inline="true" class="demo-form-inline secondLevel-form-inline">
            <el-form-item label="排放阶段：">
              <el-select v-model="vehicleEmission2" placeholder="请选择">
                <el-option label="国III" :value="3"></el-option>
                <el-option label="国IV" :value="4"></el-option>
                <el-option label="国V" :value="5"></el-option>
                <el-option label="国VI" :value="6"></el-option>
                <el-option label="新能源" :value="99"></el-option>
                <el-option v-if="customerId == 64" label="铁路运输" :value="101"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" ">
              <a class="self_btn" @click="getMaterialList2()">查询</a>
              <a class="self_btn" @click="reset2()">重置</a>
              <a class="self_btn" v-if="newAccessType" @click="materialInfoExport">导出</a>
            </el-form-item>
          </el-form>
        </div>-->
        <div class="table_box" style="height: 640px;">
          <el-table :data="tableData2" style="width: 100%" :header-cell-class-name="'thClass'" :header-row-class-name="'headTrClass'" :cell-class-name="'tdClass'"
                    :row-class-name="'trClass'" class="secondLevel_table">
            <el-table-column prop="trainNo" label="车牌号" align="center"></el-table-column>
            <el-table-column prop="grossWeight" label="毛重(吨)" align="center"></el-table-column>
            <el-table-column prop="materialName" :show-overflow-tooltip="true" label="物料名" align="center"></el-table-column>
            <el-table-column prop="section" label="车厢" align="center"></el-table-column>
            <el-table-column prop="tareWeight" label="皮重(吨)" align="center"></el-table-column>
            <el-table-column prop="suttle" label="净重(吨)" align="center"></el-table-column>
            <el-table-column prop="createTime" :show-overflow-tooltip="true" label="创建时间" align="center"></el-table-column>
            <el-table-column prop="updateTime" :show-overflow-tooltip="true" label="更新时间" align="center"></el-table-column>
            <!-- <el-table-column prop="matchType" label="匹配类型" align="center"></el-table-column> -->
          </el-table>
        </div>
        <div class="page_box secondLevel-pagination_box pagination">
          <el-pagination @current-change="handleCurrentChange2" :current-page="params2.pageNo" :page-size="params2.pageSize" layout="total,prev, pager, next, jumper" :total="page_total2">
          </el-pagination>
          <p>跳转</p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import { dateFormat } from "@/utils/tools.js";
import { DatePicker } from "@/modules/commonDatePicker";
import player from "modules/DIYcomponents/components/2_1/keyAreaMonitor/components/component/player";
import scaleBar from "modules/DIYcomponents/components/2_1/keyAreaMonitor/components/component/scaleBar";
import {mapGetters, mapState} from "vuex";
export default {
  name: "vehicleMateria",
  props: ["globalInstance"],
  components: { DatePicker },
  setup(props) {
    const globalInstance = props.globalInstance;
    return { globalInstance };
  },

  data() {
    return {
      pageInfo: 'railwayPage.vue',
      computedName: '铁路物料分类组件',
      title: '物料分类列表',
      newAccessType: this.$store.state.newAccessType,
      pickDay: "",
      between: 31,
      tableData: [],
      tableData2: [],
      materialDate: [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      material: "",
      material2: "",
      vehicleEmission: "",
      vehicleEmission2: "",
      params: {
        pageNo: 1,
        pageSize: 10,
      },
      params2: {
        pageNo: 1,
        pageSize: 10,
      },
      page_total: 0,
      page_total2: 0,
      customerId: this.globalInstance.$store.state.customerId,
      detailShow: true,
    };
  },
  computed: {
    ...mapState({
      railwayTime: 'railwayTime'
    }),
    styleType() {
      return this.globalInstance.$store.state.styleType;
    },
  },
  mounted() {
    // this.tableData = [
    //   {
    //     transportName: "带钢",
    //     transportVolume: "324",
    //     frequency: "232",
    //   },
    // ];
    if (this.railwayTime.length > 0) {
      this.materialDate = this.railwayTime;
    }
    this.getMaterialList();
  },

  methods: {
    rowClick(row) {
      console.log("row", row);
      this.vehicleEmission2 = row.vehicleEmission
        ? -(-row.vehicleEmission)
        : "";
      this.material2 = row.transportName;
      this.detailShow = false;
      this.title = '物料运输列表';
      this.getMaterialList2();
    },
    /**
     * @Description: 按物料运输导出
     * @author liqiuyu
     * @date 2023/4/19
     */
    materialInfoExport() {
      console.log('this.params2.pageSize',this.params2.pageSize,this.params2.pageNo);
      let that = this
      this.$message.info('正在导出数据……')
      let ip = this.globalInstance.cleanTransportIp;
      let str = `${ip}/transport/transport_material_detail_exportExcel?startTime=${dateFormat('YYYY-mm-dd HH:MM:SS', this.materialDate[0])}&endTime=${dateFormat(
        'YYYY-mm-dd HH:MM:SS',
        this.materialDate[1]
      )}&customerId=${this.customerId}&material=${this.material2}&vehicleEmission=${this.vehicleEmission2}
      &pageSize=${this.params2.pageSize}&pageNo=${this.params2.pageNo}`;
      let a = document.createElement('a')
      console.log(str, 'str')
      a.setAttribute('href', str)
      a.setAttribute('id', 'startTelMedicine')
      // a.target="_blank"
      document.body.appendChild(a)
      a.click()
      let elem = document.getElementById('startTelMedicine')
      elem.parentNode.removeChild(elem)
    },
    async getMaterialList2() {
      let that = this;
      let url =
        this.globalInstance.cleanTransportIp +
        "/transport/train/details";
      let res = await this.globalInstance.$apiUtils.get3(url, {
        customerId:this.customerId,
        pageNo: that.params2.pageNo,
        pageSize: that.params2.pageSize,
        materialName: that.material2,
        vehicleEmission: that.vehicleEmission2,
        startTime:  dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[0]),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[1]),
      });
      this.tableData2 = res.list;
      this.page_total2 = res.total;
    },
    handleCurrentChange2(val) {
      this.params2.pageNo = val;
      this.getMaterialList2();
    },
    returnClick() {
      this.detailShow = true;
      this.tableData2 = [];
      this.material2 = "";
      this.vehicleEmission2 = "";
      this.params2 = {
        pageNo: 1,
        pageSize: 10,
      };
      this.page_total2 = 0;
      this.title = '物料分类列表';
    },
    changeTime(time) {
      this.materialDate = time;
    },
    handleCurrentChange(val) {
      this.params.pageNo = val;
      this.getMaterialList();
    },
    reset() {
      this.material = "";
      this.materialDate = [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ];
      this.getMaterialList();
    },
    async getMaterialList() {
      let that = this;
      let url = this.globalInstance.cleanTransportIp + "/transport/train/material";
      let res = await this.globalInstance.$apiUtils.get3(url, {
        customerId:this.customerId,
        pageNo: that.params.pageNo,
        pageSize: that.params.pageSize,
        materialName: that.material,
        startTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[0]),
        endTime: dateFormat("YYYY-mm-dd HH:MM:SS", that.materialDate[1]),
      });
      this.tableData = res?.list;
      this.page_total = res?.total;
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that);
    }
  },
  unmounted() {
    this.reset();
  },
};
</script>

<style lang="scss" scoped>
.account {
  width: 100%;
  height: 100%;
  padding: 70px 80px;
  font-size: 20px;
}
.tips {
  text-align: center;
  margin-top: 50px;
}
.demo-form-inline {
  display: flex;
}
</style>
